//import React from 'react';
import React, { useState } from 'react';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home'; // Trang chủ
import About from './pages/About'; // Trang Giới thiệu
import Services from './pages/Services'; // Trang Dịch vụ

import ArticleDetail from './pages/ArticleDetail'; // Import ArticleDetail component
import CategoryArticles from './pages/CategoryArticles';
import Contact from './pages/Contact';
import Register from './pages/Register'; // Import trang ActivateAccount
import ActivateAccount from './pages/ActivateAccount'; // Import trang ActivateAccount

import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

import ProductList from './pages/ProductList';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import CustomerProfile from './pages/CustomerProfile';
import UserOrders from './pages/UserOrders';
import ProductDetails from './pages/ProductDetails';
import './App.css';
function App() {
  const [cartCount, setCartCount] = useState(0);

  const handleCartUpdate = (count) => {
    setCartCount(count);
  };
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/activate/:token" element={<ActivateAccount />} />
        <Route path="/register" element={<Register />} />
        <Route path="/profile" element={<CustomerProfile />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/products" element={<ProductList onCartUpdate={handleCartUpdate} />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/orders" element={<UserOrders />} />
        <Route path="/products/:productId" element={<ProductDetails />} />

        <Route path="/article-detail/:key" element={<ArticleDetail />} />
        <Route path="/category/:key" element={<CategoryArticles />} /> {/* Route đến trang category */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
      </Routes>

    </Router>
  );
}

export default App;
